import logo from '../../assets/logo.png'
import homeimg from '../../assets/home.jpg'
import verse1 from '../../assets/verses/verse1.jpeg'
import verse2 from '../../assets/verses/verse2.jpeg'
import verse3 from '../../assets/verses/verse3.jpeg'

import verses2026_1 from '../../assets/verses/verses2026_1.jpeg'
import verses2026_2 from '../../assets/verses/verses2026_2.jpeg'
import verses2026_3 from '../../assets/verses/verses2026_3.jpeg'

import rev_kirubanthan from '../../assets/sermons/rev_kirubandhan.png'
import pastor_stalin from '../../assets/sermons/pastor_stalin.png'

import mobile1 from '../../assets/mobile/1.png'
import mobile2 from '../../assets/mobile/2.png'


export const sermon1 = rev_kirubanthan
export const sermon2 = pastor_stalin

export const Churchlogo = logo
export const Homelogo = homeimg
export const Verse1 = verse1
export const Verse2 = verse2
export const Verse3 = verse3
export const Verse2026_1 = verses2026_1
export const Verse2026_2 = verses2026_2
export const Verse22026_3 = verses2026_3


export const mobileImg1 = mobile1
export const mobileImg2 = mobile2